const API_BASE_PATH = 'https://app.reallang.com/api/';
const WS_BASE_PATH = 'https://app.reallang.com';
const BASE_PATH = 'https://app.reallang.com/';
// const API_BASE_PATH = 'http://192.168.100.7:8000/api/';
// const WS_BASE_PATH = 'http://192.168.100.7:6001';
// const BASE_PATH = 'http://192.168.100.7:8000';

const NOTIFICATION_DURATION = 7000; // ms

const TOKEN_EXPIRATION_PERIOD = 10; // days

const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export {
  API_BASE_PATH,
  WS_BASE_PATH,
  BASE_PATH,
  NOTIFICATION_DURATION,
  TOKEN_EXPIRATION_PERIOD,
  EMAIL_REGEX,
};
